import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { StyleSheet, TextInput, TouchableWithoutFeedback, View, } from 'react-native';
const InputNativeInner = React.forwardRef(function InputNative(props, ref) {
    const inputRef = React.useRef(null);
    React.useImperativeHandle(ref, () => ({
        focus: () => {
            inputRef.current?.focus();
        },
    }));
    return (_jsx(TouchableWithoutFeedback, { onPress: () => inputRef.current?.focus(), children: _jsxs(View, { style: [
                props.multiline
                    ? styles.TokyoTextInputMultiline
                    : styles.TokyoTextInput,
                props.containerStyle ?? {},
                props.fullWidth === true ? { width: '100%' } : { width: 300 },
            ], children: [props.startEnhancer, _jsx(TextInput, { style: [props.$stickyEndEnhancer === true ? styles.innerTextInputAW : styles.innerTextInput, props.inputStyle ?? {}], testID: props.testID, value: props.value, onChangeText: props.onChangeValue, keyboardType: props.keyboardType, autoFocus: props.autoFocus, placeholder: props.placeholder, placeholderTextColor: "#aaa", secureTextEntry: props.type === 'password', autoComplete: props.autoComplete, autoCapitalize: props.autoCapitalize, autoCorrect: props.$autoCorrect, multiline: props.multiline, scrollEnabled: props.multiline !== true, ref: inputRef }), props.endEnhancer] }) }));
});
export const InputNative = React.memo(InputNativeInner);
const styles = StyleSheet.create({
    TokyoTextInputMultiline: {
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 10,
        paddingRight: 10,
        fontSize: 16,
        minHeight: 60,
        borderColor: 'white',
        borderWidth: 0,
        backgroundColor: '#37363a',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: 'white',
        borderRadius: 10,
        fontFamily: 'hiyllo',
        letterSpacing: 0.25,
    },
    TokyoTextInput: {
        paddingLeft: 10,
        paddingRight: 10,
        fontSize: 16,
        height: 40,
        borderColor: 'white',
        borderWidth: 0,
        backgroundColor: '#37363a',
        color: 'white',
        borderRadius: 10,
        fontFamily: 'hiyllo',
        letterSpacing: 0.25,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    innerTextInput: {
        minHeight: 40,
        color: 'white',
        width: 0,
        flexGrow: 1,
    },
    innerTextInputAW: {
        minHeight: 40,
        color: 'white',
    },
});
